export class BPMemberRole {
}
BPMemberRole.operator = "Operator";
BPMemberRole.shop = "Shop";
